import React, { Fragment, useRef,useEffect,useState } from 'react';
import { translate } from '../Services/translation';

const NavigationItem = ({ links = [], contentLink = null, isWorkWearCustomer, budgetRemaining, workWearText, workWearLink, isExcludedFromBudget }) => {
    const menuRef = useRef(null);
    const [isLoggedIn] = useState(window.__litium.preloadState.myPage.isBusinessCustomer)
    const [selectedWorkWear, setSelectedWorkWear] = useState(false)
    const [showSpinner, setShowSpinner] = useState(true);
    
    //timer on budget-spinner. simulate a short loading time to avoid flickering
    useEffect(() => {
        let timer;
        if (typeof isExcludedFromBudget !== 'undefined') {
            timer = setTimeout(() => setShowSpinner(false), 1000);
        }
        return () => clearTimeout(timer);
    }, [isExcludedFromBudget]);

    const toggleMenu = (e) => {
        e.preventDefault();
        menuRef.current.classList.toggle('navbar__menu--show');
    };
    const additionClass =
        contentLink && contentLink.attributes
            ? contentLink.attributes.cssValue
            : null;
    const selectedClass =
        contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';
    const hasChildrenClass = links.length > 0 ? 'has-children' : null;
    const hasNameOrChildren = (link) =>
        link.name || (link.links || []).length > 0;

    let headerNumber = document.querySelector(".header-right__text")

    const setActive = () =>{
        setSelectedWorkWear(true)
    }
    return (
        <Fragment>
            {!contentLink ? (
                <a
                    className="navbar__link--block navbar__icon--menu navbar__icon"
                    onClick={toggleMenu}
                    rel="nofollow"
                    href="#"
                    title={translate('general.menu') || 'menu'}
                ></a>
            ) : (
                <Fragment>
                    <a
                        className={`navbar__link ${selectedClass} ${
                            hasChildrenClass || ''
                        } ${additionClass || ''}`}
                        href={contentLink.url || '#'}
                        dangerouslySetInnerHTML={{ __html: contentLink.name }}
                    ></a>
                    {links.length > 0 && (
                        <i
                            className="navbar__icon--caret-right navbar__icon navbar__icon--open"
                            onClick={toggleMenu}
                        ></i>
                    )}
                </Fragment>
            )}

            {links.length > 0 && (
                <div className="navbar__menu" ref={menuRef}>
                    <div className="navbar__menu-header">
                        {!contentLink ? (
                            <>
                            <span className='navbar__mobile-header-title'>{translate('code.mobile.header.menu.title')}</span>
                            <span
                                className="navbar__icon navbar__icon--close"
                                onClick={toggleMenu}
                            ></span>
                            </>
                        ) : (
                            <Fragment>
                                <i
                                    className="navbar__icon--caret-left navbar__icon"
                                    onClick={toggleMenu}
                                ></i>
                                <span
                                    className="navbar__title"
                                    onClick={toggleMenu}
                                    dangerouslySetInnerHTML={{
                                        __html: contentLink.name,
                                    }}
                                ></span>
                            </Fragment>
                        )}
                    </div>
                    <ul className="navbar__menu-links">
                        {links.length > 0 && links.map((link, index) => {
                                    if(!(isWorkWearCustomer && index === 0)){
                                        return (
                                            hasNameOrChildren(link) && (
                                                <li
                                                    className="navbar__item"
                                                    key={index}
                                                >
                                                    <NavigationItem
                                                        links={link.links}
                                                        contentLink={link}
                                                    />
                                                </li>
                                            )
                                        )
                                    }
                                    return null
                                })}
                            {workWearText !== "" && workWearLink !== "" &&(
                                <li className="navbar__item" key={workWearLink}>
                                    <a href={workWearLink} className={`${selectedWorkWear ? 'navbar__link--selected' : '', 'navbar__link'}`} onClick={(e) => {setActive()}}>{workWearText}</a>
                                </li>
                            )}
                    </ul>
                    {isLoggedIn && isWorkWearCustomer && (
                        <div className="navbar__mobile-budget">
                            <p>{translate('code.header.budget.info.text')} </p>
                            {showSpinner ? (
                                <div className='spinner spinner--small'></div>
                            ) : (
                                <span> 
                                    {budgetRemaining} {translate('code.currency.short.text')} 
                                </span>
                            )}
                        </div>
                    )}
                    <div className='mobile-contact-number'>
                    { headerNumber && (
                    <div dangerouslySetInnerHTML = {{__html:document.querySelector(".header-right__text").cloneNode(true).outerHTML}} />
                    )}
                    </div>

                </div>
            )}
        </Fragment>
    );
};

export default NavigationItem;
